<button class="btn more-less-button btn-block"
        *ngIf="isShowMore || isShowFewer || isShowAll"
        [attr.data-automation-id]="isShowFewer ? 'less-button-' + facetPluralName : 'more-button-' + facetPluralName"
        (click)="toggleEvent()">
  <span>
    <ng-container *ngIf="isShowAll">
      {{getTranslationKey('all') | translate}}
    </ng-container>

    <ng-container *ngIf="isShowMore">
      {{getTranslationKey('more') | translate}}
    </ng-container>

    <ng-container *ngIf="isShowFewer">
      {{getTranslationKey('fewer') | translate}}
    </ng-container>
  </span>
  <ng-container *ngIf="isShowMore"> ({{leftCount}})</ng-container>
  <ng-container *ngIf="isShowAll"> ({{totalResults}})</ng-container>
</button>